import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getAcademicYears } from "services/academicYearsService";
import { message } from "antd";
import { updateAcademicYear as updateAcademicYearAction } from "../../../../redux/slicers/authSlice";
import { store } from "../../../../redux/store";
import { updateAcademicYear } from "services/userService";

export const useAcademicYears = () => {
    const [academicYears, setAcademicYears] = useState<any[]>([]);
    const { t } = useTranslation();

    const fetchAcademicYears = async () => {
        try {
            const response = await getAcademicYears();
            setAcademicYears(response);
        } catch (error) {
            console.error("Error fetching academic years:", error);
            message.error("Failed to fetch academic years.");
        }
    };

    const updateUserAcademicYear = async (academicYearId: string) => {
        try {
            const response = await updateAcademicYear(academicYearId);
            store.dispatch(updateAcademicYearAction(response));
            message.success("Academic year updated successfully.");
            window.location.reload();
        } catch (error) {
            console.error("Error updating academic year:", error);
            message.error("Failed to update academic year.");
        }
    };


    return { fetchAcademicYears, academicYears, updateUserAcademicYear };
};





